module.exports = __webpack_public_path__ + "img/8345cf5.png";